<template>
  <div id="web_config">
      <TemplateLayout>
        <!-- Page Heading -->
        <h1 class="h3 mb-2 text-gray-800"> <label class="text-gray-800">ตั้งค่าพื้นฐาน</label></h1>
        <p class="mb-4">ผู้ดูแลระบบสามารถแก้ไขตั้งค่าพื้นฐาน เพื่อใช้ในการสำหรับระบบ เช่น การส่งอีเมลแจ้งเตือน</p>

        
        <form method="post" @submit.prevent="saveWebConfig">
            <div class="card shadow mb-4">
                <div class="card-header py-3">
                
                    <h6 class="m-0 font-weight-bold text-primary">ตั้งค่าพื้นฐาน</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>ชื่อเว็บไซต์</label>
                            <input required type="text" v-model="web_name" class="form-control"/>
                        </div>
                        <div class="col-lg-7">
                            <label>เว็บไซต์ URL</label>
                            <input required type="text" v-model="web_url" class="form-control"/>
                        </div>

                        <div class="col-lg-4">
                            <label>อีเมล์</label>
                            <input required type="text" v-model="email_host" class="form-control"/>
                        </div>
                        <div class="col-lg-4">
                            <label>ชื่อผู้ใช้ (Username) สำหรับอีเมล์</label>
                            <input required type="text" v-model="email_username" class="form-control"/>
                        </div>
                        <div class="col-lg-4">
                            <label>รหัสผ่าน (Password) สำหรับอีเมล์</label>
                            <input required type="text" v-model="email_password" class="form-control"/>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button id="btnSaveData" type="submit" class="btn btn-primary">
                        <i class="fas fa-save fa-fw"></i>
                        บันทึกข้อมูล
                    </button>
                </div>
            </div>
        </form>
      </TemplateLayout>
  </div>
</template>

<script>

import TemplateLayout from "@/components/layout/TemplateLayout.vue";
import { MasterService } from '@/services/master.service';
import { AlertService } from '@/services/alert.service';

export default {
  name: 'WebConfiguration',
  components: {
    TemplateLayout
  },
  data() {
     return {
        objective: "system_config",
        web_name: "",
        web_url: "",
        email_host: "",
        email_username: "",
        email_password: ""
      }
  },
  methods: {
      async bindWebDetail()
      {
        const respons = await MasterService.getMasterList(this.objective);
        this.web_name = respons.web_name;
        this.web_url = respons.web_url;
        this.email_host = respons.email_host;
        this.email_username = respons.email_username;
        this.email_password = respons.email_password;
      },
      async saveWebConfig()
      {
        if(AlertService.confirm(window.$("#btnSaveData"),"ยืนยันรายการ?")){
            AlertService.loading(true,"บันทึกรายการ");
            var data = {
                web_name: this.web_name,
                web_url: this.web_url,
                email_host: this.email_host,
                email_username: this.email_username,
                email_password: this.email_password
            };
            const respons = await MasterService.saveData("put",this.objective,data);
            if(respons.status == 200){
                AlertService.success(respons.message);
            }else{
                AlertService.error(respons.message)
            }
            AlertService.loading(false);
            }
        return false;
      }
  },
  mounted() {
    this.bindWebDetail();
  },
}

</script>

<style>

</style>